module.exports = __webpack_public_path__ + "static/img/wayside-sign-novalloy.6812ff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/interpretive/wayside-sign-novalloy.jpg
// module id = 1026
// module chunks = 0